export default __webpack_public_path__ + "static/media/toggle-icon.533861ff.svg";